import React from 'react';

import { Row, Col } from 'components/layout';
import Icon from 'components/Icon';

import Feedback from '../Feedback';

import { labelsByVariant } from '../../constants';

const EmptyView = ({ variant }) => (
  <Row justify="center" align="middle" style={{ height: '100%' }}>
    <Col style={{ textAlign: 'center' }}>
      <Feedback
        title="Empty"
        message={labelsByVariant[variant].emptyDescription}
        img={<Icon name={variant === 'v2' ? "info" : "alert-circle"} color="#B9C2C9" />}
      />
    </Col>
  </Row>
);

export default EmptyView;